import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const endPointDirecciones = environment.hostService + '/DireccionesPersonal';

@Injectable({
  providedIn: 'root'
})
export class DireccionesPersonalService {

  constructor(private _http: HttpClientService) { }

  getHistoryByClase(idPersonal: number, idClaseDireccion: number): Observable<any>
  {
    return this._http.get<any>({ url: endPointDirecciones + '/GetHistoryByClaseDireccion/' + idPersonal + '/' + idClaseDireccion })
  }

  getDirecciones(id, agrupar): Observable<any>
  {
    return this._http.get<any>({ url: endPointDirecciones + '/GetDireccionesPersonalByPersonalId/' + id + '/' + agrupar, cacheMins: 0 })
  }

  guardar(data, cortarRegistro): Observable<any>
  {
    return this._http.post<any>({ url: endPointDirecciones + '/Save/' + cortarRegistro, body: data, cacheMins: 0 });
  }

  eliminar(id): Observable<any>
  {
    return this._http.get<any>({ url: endPointDirecciones + '/Delete?id=' + id });
  }

  getFormatoImportacion() {
    const formato = [
      { personal: 0,
        desde: '00/00/0000',
        hasta: '00/00/0000',
        clase: '', 
        calle: '',
        nro: '',
        piso: '',
        dpto: '',
        localidad: '',
        provincia: '',
        codpos: '',
        pais: '',
        telefono: '',
        observaciones: '',
        errores: ['No Completar']}
    ];

    //claseDireccion, provincia y pais se deben validar que existan

    return formato;
  }
}
